/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'
import ClipLoader from 'react-spinners/ClipLoader'
import { baseColor } from '../../../../lib/styles/colors'

const loadingCss = css`
  position: fixed;
  margin: auto;
`

const loadingContainerCss = css`
  text-align: center;
`

const Loading = () => (
  <div css={loadingContainerCss}>
    <ClipLoader color={baseColor} css={loadingCss} loading size={75} />
  </div>
)

export default Loading
